import React from 'react'
import styles from './svg.module.scss'

const Banknote = ({
  viewBox = '0 0 24 24',
  size = 24,
  color = 'primaryColor',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={styles[`${color}Stroke`]}
      style={{ fill: 'none' }}
    >
      <rect width="20" height="12" x="2" y="6" rx="2" />
      <circle cx="12" cy="12" r="2" />
      <path d="M6 12h.01M18 12h.01" />
    </svg>
  )
}

export default Banknote
